import { render } from "./readerFormatModal.vue?vue&type=template&id=489b2ae0&scoped=true"
import script from "./readerFormatModal.vue?vue&type=script&lang=js"
export * from "./readerFormatModal.vue?vue&type=script&lang=js"

import "./readerFormatModal.vue?vue&type=style&index=0&id=489b2ae0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489b2ae0"]])

export default __exports__